/**
 * sort the object list by key
 * @param {string} key - key to sort
 * @param {Array<{}>} list - list of objects to sort
 * @return {Array<{}>} list of objects sorted
 */
export function sortObjectList(key, list) {
  return list.sort(function (a, b) {
    if (a[key] > b[key]) {
      return 1
    }
    if (a[key] < b[key]) {
      return -1
    }
    // a must be equal to b
    return 0
  })
}
